import React from 'react'
import { Button, Col, Form, Modal, Row, Alert } from 'react-bootstrap'
import * as Yup from 'yup'
import type { FormikErrors, FormikTouched } from 'formik'
import type { AlertState } from '../common'

interface PageCopyFormValues {
  name: string
  draftNumber: number
  copyLayoutInfo: boolean
}

interface PageCopyFormProps {
  values: PageCopyFormValues
  errors: FormikErrors<PageCopyFormValues>
  touched: FormikTouched<PageCopyFormValues>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  fetching: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
  alert?: AlertState | null
}

const _PageCopyForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  fetching,
  title,
  submitButtonText,
  onClickCancel,
  alert
}: PageCopyFormProps) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    {alert?.show && alert?.alertBody && (
      <Alert className='copy-page-error-alert' variant='danger'>
        {alert.alertBody}
      </Alert>
    )}
    <Form noValidate onSubmit={handleSubmit}>
      <Modal.Body>
        <p>以下の紙面を複製します。よろしいですか？</p>
        <p>複製元紙面名称：{values.name}</p>
        <Row>
          <Form.Group as={Col}>
            <Form.Label column>複製後紙面ドラフト数</Form.Label>
            <Form.Control
              id='draftNumberInput'
              name='draftNumber'
              type='number'
              size='sm'
              value={values.draftNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!(touched.draftNumber && errors.draftNumber)}
            />
            <Form.Control.Feedback type='invalid'>{errors.draftNumber}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label column>複製オプション</Form.Label>
            <Col>
              <Form.Check
                type='switch'
                id='copyLayoutInfo'
                label='割り付け情報も複製する'
                name='copyLayoutInfo'
                checked={values.copyLayoutInfo}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!(touched.copyLayoutInfo && errors.copyLayoutInfo)}
              />
            </Col>
          </Form.Group>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <Button type='submit' disabled={fetching}>
          {submitButtonText}{' '}
        </Button>
      </Modal.Footer>
    </Form>
  </>
)

export const PageCopyForm = Object.assign(_PageCopyForm, {
  schema: Yup.object().shape({
    name: Yup.string().required(),
    copyLayoutInfo: Yup.boolean().required(),
    draftNumber: Yup.number().required().min(1)
  })
})
